//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
import { videoPlayer } from 'vue-video-player'
export default {
  components: {
    videoPlayer
  },

  props: {
    src: {
      type: String,
      default: null
    },
    poster: {
      type: String,
      default: ''
    },
    width: {
      type: Number
    },
    height: {
      type: Number
    },
    preload: {
      type: String,
      default: 'auto'
    }
  },

  data: () => ({
    playerOptions: {
      // videojs options
      // muted: true,
      // width: 300,
      // height: 300 * 9 / 16,
      // language: 'en',
      // playbackRates: [0.7, 1.0, 1.5, 2.0],
      // sources: [{
      //   type: 'video/mp4',
      //   src: 'https://img01.wanfangche.com/video/Camping_World_Captures_The_West.mp4'
      // }],
      // poster: '/static/images/author.jpg'
    }
  }),

  computed: {
    player () {
      return this.$refs.videoPlayer.player
    }
  },

  mounted () {
    this.playerOptions = {
      // videojs options
      muted: false,
      width: this.width || this.$el.clientWidth,
      height: this.height || Math.ceil(this.$el.clientWidth * 9 / 16),
      language: 'en',
      playbackRates: [0.7, 1.0, 1.5, 2.0],
      sources: [{
        type: 'video/mp4',
        src: this.src
      }],
      poster: this.poster,
      preload: this.preload
    }
  },
  methods: {
    // listen event
    onPlayerPlay (player) {
      // console.log('player play!', player)
    },

    onPlayerPause (player) {
      // console.log('player pause!', player)
    },
    // ...player event

    // or listen state event
    playerStateChanged (playerCurrentState) {
      // console.log('player current update state', playerCurrentState)
    },

    // player is ready
    playerReadied (player) {
      // console.log('the player is readied', player)
      // you can use it to do something...
      // player.[methods]
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/video-view/video-player.vue